import React from 'react';
import SAlert from './Alert.styles';
import { TAlertProps } from './Alert.types';

const Alert = ({ message, ...props }: TAlertProps) => {
  return <SAlert role="heading" aria-level={1} message={message} {...props} />;
};

export default Alert;
